import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export const createFilterField = async (filter_field) => {
  return axios
    .post('/manage/filter_fields', {
      filter_field,
    })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyFilterField = async (ff, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/filter_fields/${ff.id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        console.error(error.response);
        callback(error);
      });
  });
};
